<!-- <div class="container-fluid" style="overflow: auto;"> -->
<div class="container-fluid p-0">
  <!-- <div class="card" #appendTo>
    <div class="card-body no-border">
      <div class="card-title">
        <h3 style="text-align: left;"><fa-icon class="fa-solid fa-duotone"
            [icon]="['fad', 'memo-circle-info']"></fa-icon> About
        </h3>
      </div>
      <div style="margin-top: 40px; margin-left: auto; margin-right: auto; ">
        <div class="mt-4 p-5 bg-primary text-white rounded">
          <h4>Its the Angular/Electron Database Management Application</h4>
          <p>Version: {{version}}</p>
          <p>Api Url: {{apiUrl}}</p>
        </div>
      </div>
    </div>
  </div> -->
  <div class="home-section" style="background-color: #4D6EA3;">
    <div class="row m-0" >
      <div class="col-12 col-lg-6">
        <div style="padding: 0px 15px; text-align: center;" class="d-block d-lg-none">
          <img src="assets/images/home2.jpg" style="border-radius: 15px; max-height: 40vh; min-height: 300px;">
        </div>
        <div style="padding: 0px 15px;" class="d-none d-lg-block">
          <img src="assets/images/home2.jpg" style="margin: 0px 15px; border-radius: 15px; width: 100%; max-height: 600px; min-height: 300px; object-fit: cover;">
        </div>
        
      </div>
      <div class="col-12 col-lg-6">
        <div class="flexv">
          <h2 style="margin-bottom: 40px; color: white; margin-top: 30px;">About Reflexis</h2>
            <p class="text2" style="color: white;">Universities, health services, and organisations
              seeking to integrate Reflexis across their courses,
              placements, and training programs are encouraged
              to contact us regarding large-scale adoption and
              implementation support.</p>
        </div>
       
      </div>
    </div>
  </div>
</div>
